"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var sortBy_1 = __importDefault(require("lodash/sortBy"));
var flatten_1 = __importDefault(require("lodash/flatten"));
var filter_1 = __importDefault(require("lodash/filter"));
var time_1 = require("../helpers/time");
var json_1 = require("../helpers/json");
var CalendarService = /** @class */ (function () {
    function CalendarService(DrivesFilterService, CalendarModel, $state, $rootScope, UserService, $timeout, VueStoreFactory) {
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.UserService = UserService;
        this.VueStoreFactory = VueStoreFactory;
        this.DrivesFilterService = DrivesFilterService;
        this.CalendarModel = CalendarModel;
        this.$timeout = $timeout;
        /**
          * The collection to be sent to the calendar
          */
        this.calendar = [];
        /**
         * The collection to be sent to the agenda
         */
        this.agenda = [];
        this.getCalendarItems = this.getCalendarItems.bind(this);
        this.setCalendarItems = this.setCalendarItems.bind(this);
        this.getAgendaItems = this.getAgendaItems.bind(this);
        this.setAgendaItems = this.setAgendaItems.bind(this);
        this.setCalendarView = this.setCalendarView.bind(this);
        this.getCalendarView = this.getCalendarView.bind(this);
        this.clearItems = this.clearItems.bind(this);
        this.processCalendar = this.processCalendar.bind(this);
        this.processAgenda = this.processAgenda.bind(this);
        this.handleEventClick = this.handleEventClick.bind(this);
        this.handleDateClick = this.handleDateClick.bind(this);
        this.handleCalDestroy = this.handleCalDestroy.bind(this);
        this.getCalendarEvents = this.getCalendarEvents.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.disableFullCalendarControls = this.disableFullCalendarControls.bind(this);
        this.enableFullCalendarControls = this.enableFullCalendarControls.bind(this);
    }
    /**
     * Get the calendar items
     */
    CalendarService.prototype.getCalendarItems = function () {
        return this.calendar;
    };
    /**
     * Set the calendar items
     * @param data
     */
    CalendarService.prototype.setCalendarItems = function (data) {
        this.calendar = data;
    };
    /**
     * Get the agenda items
     * @returns {Array|*}
     */
    CalendarService.prototype.getAgendaItems = function () {
        return this.agenda;
    };
    /**
     * Set the agenda items
     * @param data
     */
    CalendarService.prototype.setAgendaItems = function (data) {
        this.agenda = data;
    };
    CalendarService.prototype.clearItems = function () {
        this.calendar = [];
        this.agenda = [];
    };
    /**
     * Set/get the calendar view (month/week/day)
     * @param viewType
     */
    CalendarService.prototype.setCalendarView = function (viewType) {
        this.calendarView = viewType;
    };
    CalendarService.prototype.getCalendarView = function () {
        return this.calendarView;
    };
    CalendarService.prototype.processAgenda = function (response) {
        var _this = this;
        var _allItems = [];
        if (typeof response.data.drives !== "undefined") {
            response.data.drives
                .filter(function (drive) {
                drive.date = drive.drive_date;
                drive.startTime = (0, moment_1.default)((0, time_1.timeStringToDate)(drive.start_time)).format("h:mm a");
                drive.typeDisplay = drive.type.name;
                drive.type = "Drive Session";
                if (drive.private === "Y" && drive.observation === false) {
                    drive.typeDisplay = drive.typeDisplay + " (Hidden)";
                }
                drive.timestamp = (0, moment_1.default)((0, time_1.dateTimeStringToDate)(drive.drive_date + " " + drive.start_time)).unix();
                if (drive.location) {
                    drive.location = (0, json_1.isJson)(drive.location)
                        ? JSON.parse(drive.location)
                        : drive.location;
                }
                var minutes = moment_1.default.duration(drive.session_length, "minutes");
                var datetime = (0, moment_1.default)((0, time_1.dateTimeStringToDate)(drive.date + " " + drive.start_time));
                drive.endTime = (0, moment_1.default)((0, time_1.timeStringToDate)(drive.start_time))
                    .add(minutes, "minutes")
                    .format("h:mm a");
                drive.duration = moment_1.default
                    .duration(drive.session_length, "minutes")
                    .asHours();
                // @ts-ignore
                drive.duration = moment_1.default.duration(drive.duration, "hours").format("h [hours], m [minutes]");
                drive.styling = _this.CalendarModel.getStylingForDriveCard(drive);
                drive.actionRequired = drive.hasUngradedReportcards === true && drive.status === "Taken" && datetime.isBefore((0, moment_1.default)());
                return drive; //return drive.status === 'Taken';
            })
                .forEach(function (drive) {
                _allItems.push(drive);
            });
        }
        if (typeof response.data.courses !== "undefined") {
            response.data.courses
                .filter(function (course) {
                var minutes = moment_1.default.duration(course.duration, "minutes");
                course.type = "Course";
                course.styling = "course";
                course.typeDisplay = course.course_type_name + ": " + course.name;
                course.location = (0, json_1.isJson)(course.location)
                    ? JSON.parse(course.location)
                    : course.location;
                course.timestamp = (0, moment_1.default)((0, time_1.dateTimeStringToDate)(course.date + " " + course.time)).unix();
                course.duration = moment_1.default
                    .duration(course.duration, "minutes")
                    .asHours();
                // @ts-ignore
                course.duration = moment_1.default.duration(course.duration, "hours").format("h [hours], m [minutes]");
                if (course.classes && course.classes.length > 0) {
                    course.classes = course.classes.map(function (classDate) {
                        var classDateWithCourseInfo = {
                            //refine course info
                            date: (0, moment_1.default)(classDate.start).format("YYYY-MM-DD"),
                            startTime: (0, moment_1.default)(classDate.start).format("h:mm a"),
                            endTime: (0, moment_1.default)(classDate.end).format("h:mm a"),
                            class_id: classDate.id,
                            instructor: classDate.instructor,
                            location: course.location,
                            classroom: course.classroom,
                            id: course.id,
                            name: course.name,
                            type: course.type,
                            course_type_name: course.course_type_name,
                            // duration: course.duration,
                            typeDisplay: course.typeDisplay,
                            timestamp: (0, moment_1.default)(classDate.start).unix(),
                            label: course.label,
                            styling: course.styling,
                        };
                        return classDateWithCourseInfo;
                    });
                }
                else {
                    course.end_time = (0, moment_1.default)((0, time_1.timeStringToDate)(course.time))
                        .add(minutes, "minutes")
                        .format("HH:mm:ss");
                    course.endTime = (0, moment_1.default)((0, time_1.timeStringToDate)(course.time))
                        .add(minutes, "minutes")
                        .format("h:mm a");
                    course.startTime = (0, moment_1.default)((0, time_1.timeStringToDate)(course.time)).format("h:mm a");
                }
                return course;
            })
                .forEach(function (course) {
                if (course.classes && course.classes.length > 0) {
                    _allItems.push.apply(_allItems, course.classes);
                }
                else
                    _allItems.push(course);
            });
        }
        if (typeof response.data.events !== "undefined") {
            response.data.events
                .filter(function (event) {
                event.typeDisplay = "Event: " + event.name;
                event.styling = "event";
                event.type = "Event";
                event.location = (0, json_1.isJson)(event.location)
                    ? JSON.parse(event.location)
                    : event.location;
                event.timestamp = (0, moment_1.default)((0, time_1.dateTimeStringToDate)(event.date.split(" ")[0] + " " + event.time)).unix();
                var minutes = moment_1.default.duration(event.duration, "minutes");
                event.endTime = (0, moment_1.default)((0, time_1.timeStringToDate)(event.time))
                    .add(minutes, "minutes")
                    .format("h:mm a");
                event.startTime = (0, moment_1.default)((0, time_1.timeStringToDate)(event.time)).format("h:mm a");
                event.duration = moment_1.default.duration(event.duration, "minutes").asHours();
                // @ts-ignore
                event.duration = moment_1.default.duration(event.duration, "hours").format("h [hours], m [minutes]");
                return event;
            })
                .forEach(function (event) {
                _allItems.push(event);
            });
        }
        if (typeof response.data.timeoffrequests !== "undefined") {
            response.data.timeoffrequests
                .filter(function (rto) {
                rto.typeDisplay = "RTO";
                if (!rto.rto_type) {
                    rto.rto_type = rto.type;
                    rto.type = "RTO";
                }
                var _start_ = (0, moment_1.default)((0, time_1.dateTimeStringToDate)(rto.begin));
                var _end_ = (0, moment_1.default)((0, time_1.dateTimeStringToDate)(rto.end));
                rto.timestamp = _start_.unix();
                // Dont show times for full or range type RTO
                if (rto.rto_type === "full" || rto.rto_type === "range") {
                    var s_moment = (0, moment_1.default)(_this.DrivesFilterService.getDate(), "YYYY-MM-DD")
                        .hours(23)
                        .minutes(59);
                    var e_moment = (0, moment_1.default)(_this.DrivesFilterService.getDate(), "YYYY-MM-DD")
                        .hours(0)
                        .minutes(0);
                    rto.endTime = s_moment.format("h:mm a");
                    rto.startTime = e_moment.format("h:mm a");
                    // @ts-ignore
                    rto.duration = moment_1.default.duration(s_moment.diff(e_moment)).format("h [hours], m [minutes]");
                }
                else {
                    rto.endTime = (0, moment_1.default)(rto.end, "YYYY-MM-DD HH:mm:s").format("h:mm a");
                    rto.startTime = (0, moment_1.default)(rto.begin, "YYYY-MM-DD HH:mm:s").format("h:mm a");
                    // @ts-ignore
                    rto.duration = moment_1.default.duration(_end_.diff(_start_)).format("h [hours], m [minutes]");
                }
                return rto;
            })
                .forEach(function (rto) {
                _allItems.push(rto);
            });
        }
        return (0, sortBy_1.default)(_allItems, function (item) {
            return item.timestamp;
        });
    };
    CalendarService.prototype.processCalendar = function (response) {
        var _allItems = [];
        if (typeof response.data.drives !== "undefined") {
            response.data.drives
                .filter(function (drive) {
                drive.date = (0, moment_1.default)((0, time_1.dateStringToDate)(drive.drive_date)).format("YYYY-MM-DD");
                drive.startTime = (0, moment_1.default)((0, time_1.timeStringToDate)(drive.start_time)).format("HH:mm:ss");
                drive.timestamp = (0, moment_1.default)((0, time_1.dateTimeStringToDate)(drive.drive_date + " " + drive.start_time)).unix();
                //calendarDisplay used in vue cal
                drive.calendarDisplay = drive.label.type;
                drive.typeDisplay = drive.label.type;
                drive.type = "Drive Session";
                if (drive.private === "Y") {
                    drive.typeDisplay += " (Hidden)";
                    drive.calendarDisplay += " (Hidden)";
                }
                if (drive.student_id !== 0) {
                    drive.calendarDisplay = "".concat(drive.student_name, " - ").concat(drive.typeDisplay);
                }
                //agendaDisplay used in miniCalendarAgenda.vue (agenda on side of main cal)
                drive.agendaDisplay = drive.calendarDisplay;
                if (drive.calendarDisplay === "Drive") {
                    drive.calendarDisplay = "Open Session";
                }
                var minutes = moment_1.default.duration(drive.session_length, "minutes");
                drive.endTime = (0, moment_1.default)((0, time_1.timeStringToDate)(drive.start_time))
                    .add(minutes, "minutes")
                    .format("h:mm a");
                //end_time format is different, needs to be 24hr time for safari/firefox bug
                drive.end_time = (0, moment_1.default)((0, time_1.timeStringToDate)(drive.start_time))
                    .add(minutes, "minutes")
                    .format("HH:mm:ss");
                drive.duration = moment_1.default
                    .duration(drive.session_length, "minutes")
                    .asHours();
                drive.duration = moment_1.default.duration(drive.duration, "hours").humanize();
                //start and end are for vue full calendar
                drive.start = (0, time_1.dateTimeStringToDate)(drive.date + " " + drive.start_time);
                drive.end = (0, time_1.dateTimeStringToDate)(drive.date + " " + drive.end_time);
                return drive; //return drive.status === 'Taken';
            })
                .forEach(function (drive) {
                _allItems.push(drive);
            });
        }
        if (typeof response.data.courses !== "undefined") {
            response.data.courses
                .filter(function (course) {
                course.type = "Course";
                course.typeDisplay = course.name;
                course.calendarDisplay = course.name;
                if (course.private === "Y") {
                    course.calendarDisplay += " (Hidden)";
                }
                course.agendaDisplay = course.calendarDisplay;
                // course.location = angular.fromJson( course.location );
                course.date = (0, moment_1.default)((0, time_1.dateStringToDate)(course.date)).format("YYYY-MM-DD");
                course.timestamp = (0, moment_1.default)((0, time_1.dateTimeStringToDate)(course.date + " " + course.time)).unix();
                if (course.classes && course.classes.length > 0) {
                    course.classes = course.classes.map(function (classDate) {
                        var classDateWithCourseInfo = {
                            //refine course info
                            date: "".concat((0, time_1.dateTimeStringToDate)(classDate.start).getFullYear(), "-").concat((0, time_1.dateTimeStringToDate)(classDate.start).getMonth(), "-").concat((0, time_1.dateTimeStringToDate)(classDate.start).getDate()), // moment(classDate.start).format("YYYY-MM-DD"),
                            start: (0, time_1.dateTimeStringToDate)(classDate.start),
                            end: (0, time_1.dateTimeStringToDate)(classDate.end),
                            class_id: classDate.id,
                            instructor_id: classDate.instructor.id,
                            instructor_name: classDate.instructor.name,
                            location_name: course.location_name,
                            classroom_name: course.classroom_name,
                            id: course.id,
                            label: course.label,
                            name: course.name,
                            type: course.type,
                            course_type_name: course.course_type_name,
                            duration: course.duration,
                            calendarDisplay: course.calendarDisplay,
                            timestamp: parseInt(((0, time_1.dateTimeStringToDate)(classDate.start).getTime() / 1000).toFixed(0)), // moment().unix(),
                            agendaDisplay: course.agendaDisplay,
                        };
                        return classDateWithCourseInfo;
                    });
                }
                else {
                    course.startTime = (0, moment_1.default)(course.time, "HH:mm:s").format("h:mm a");
                    var minutes = moment_1.default.duration(course.duration, "minutes");
                    course.endTime = (0, moment_1.default)(course.time, "HH:mm:s")
                        .add(minutes, "minutes")
                        .format("h:mm a");
                    course.end_time = (0, moment_1.default)(course.time, "HH:mm:s")
                        .add(minutes, "minutes")
                        .format("HH:mm:ss");
                    //start and end are for vue full calendar
                    course.start = (0, time_1.dateTimeStringToDate)(course.date + " " + course.time);
                    course.end = (0, time_1.dateTimeStringToDate)(course.date + " " + course.end_time);
                }
                course.duration = moment_1.default
                    .duration(course.duration, "minutes")
                    .asHours();
                course.duration = moment_1.default
                    .duration(course.duration, "hours")
                    .humanize();
                return course;
            })
                .forEach(function (course) {
                if (course.classes && course.classes.length > 0) {
                    _allItems.push.apply(_allItems, course.classes);
                }
                else {
                    _allItems.push(course);
                }
            });
        }
        if (typeof response.data.events !== "undefined") {
            response.data.events
                .filter(function (event) {
                var date = event.calDate.split("/");
                event.date = (0, moment_1.default)(new Date(parseInt(date[2]), parseInt(date[0]) - 1, parseInt(date[1]), 0, 0, 0)).format("YYYY-MM-DD");
                var eventdatetime = event.date + " " + event.time;
                event.typeDisplay = "Event";
                event.calendarDisplay = event.name;
                if (event.private === "Y") {
                    event.calendarDisplay += " (Hidden)";
                }
                event.type = "Event";
                event.agendaDisplay = event.calendarDisplay;
                // event.location = angular.fromJson( event.location );
                event.timestamp = (0, moment_1.default)((0, time_1.dateTimeStringToDate)(event.date + " " + event.time)).unix();
                var minutes = moment_1.default.duration(event.duration, "minutes");
                event.endTime = (0, moment_1.default)((0, time_1.timeStringToDate)(event.time))
                    .add(minutes, "minutes")
                    .format("h:mm a");
                event.end_time = (0, moment_1.default)((0, time_1.timeStringToDate)(event.time))
                    .add(minutes, "minutes")
                    .format("HH:mm:ss");
                event.startTime = (0, moment_1.default)((0, time_1.timeStringToDate)(event.time)).format("h:mm a");
                event.duration = moment_1.default.duration(event.duration, "minutes").asHours();
                event.duration = moment_1.default.duration(event.duration, "hours").humanize();
                //start and end are for vue full calendar
                event.start = (0, time_1.dateTimeStringToDate)(eventdatetime);
                event.end = (0, time_1.dateTimeStringToDate)(event.date + " " + event.end_time);
                return event;
            })
                .forEach(function (event) {
                _allItems.push(event);
            });
        }
        if (typeof response.data.timeoffrequests !== "undefined") {
            response.data.timeoffrequests.forEach(function (rto) {
                rto.type = "RTO";
                rto.calendarDisplay = rto.type + " " + rto.instructor_name;
                rto.agendaDisplay = rto.calendarDisplay;
                var _start_ = (0, moment_1.default)((0, time_1.dateTimeStringToDate)(rto.begin));
                var _end_ = (0, moment_1.default)((0, time_1.dateTimeStringToDate)(rto.end));
                rto.timestamp = _start_.unix();
                _allItems.push(rto);
            });
        }
        return _allItems;
    };
    CalendarService.prototype.goToAgenda = function (data) {
        var dateStr = data.dateStr, context = data.context;
        if (typeof context !== undefined) {
            switch (context) {
                case "student":
                    this.$state.go("drivecoach.student.drives.agenda", { date: dateStr });
                    break;
                case "admin":
                    this.$state.go("drivecoach.admin.agenda", { date: dateStr });
                    break;
                case "instructor":
                    this.$state.go("drivecoach.instructor.dashboard.agenda", {
                        date: dateStr,
                    });
                    break;
                case "instructor_team_calendar":
                    this.$state.go("drivecoach.instructor.dashboard.teamagenda", {
                        date: dateStr,
                    });
                    break;
                default:
                    break;
            }
        }
    };
    CalendarService.prototype.openAdminRTOModal = function (data) {
        this.$rootScope.$broadcast("OPEN_RTO_MODAL", data);
    };
    CalendarService.prototype.handleAdminEventClick = function (data) {
        switch (data.eventName) {
            case "SESSION":
                this.$state.go("drivecoach.admin.drives.edit", { id: data.id });
                break;
            case "OPEN SESSION":
                this.$state.go("drivecoach.admin.drives.edit", { id: data.id });
                break;
            case "COURSE":
                var course = {
                    id: data.id,
                    class_id: data.event.extendedProps.class_id,
                    date: (0, time_1.dateTimeStringToDate)(data.dateStr + " " + data.event.extendedProps.eventStart).toLocaleDateString(),
                    start: (0, time_1.dateTimeStringToDate)(data.dateStr + " " + data.event.extendedProps.eventStart).toLocaleTimeString("en-US", { hour: "numeric", minute: "numeric" }),
                    end: (0, time_1.dateTimeStringToDate)(data.dateStr + " " + data.event.extendedProps.eventEnd).toLocaleTimeString("en-US", { hour: "numeric", minute: "numeric" }),
                };
                this.VueStoreFactory.dispatch("SET_VIEW_COURSE", course);
                this.$state.go("drivecoach.admin.courses.view", {
                    courseId: data.id,
                });
                break;
            case "EVENT":
                this.$state.go("drivecoach.admin.events.edit", {
                    eventId: data.id,
                });
                break;
            case "RTO":
                this.openAdminRTOModal(data);
                break;
            default:
                break;
        }
    };
    CalendarService.prototype.handleInstructorEventClick = function (data) {
        this.goToAgenda(data);
    };
    CalendarService.prototype.handleEventClick = function (data) {
        //data is object with 'context', 'id', eventName, event, and date
        var id = data.id, context = data.context, eventName = data.eventName, event = data.event, date = data.date;
        if (typeof context !== undefined) {
            switch (context) {
                case "admin":
                    this.handleAdminEventClick(data);
                    break;
                case "instructor":
                    this.handleInstructorEventClick(data);
                    break;
                case "instructor_team_calendar":
                    this.handleInstructorEventClick(data);
                    break;
                default:
                    break;
            }
        }
    };
    CalendarService.prototype.handleDateClick = function (data) {
        this.goToAgenda(data);
    };
    CalendarService.prototype.getFilterQuery = function (data) {
        var start_date = data.start_date, end_date = data.end_date, context = data.context;
        var query = structuredClone(this.DrivesFilterService.getFilterParameters());
        query.start_date = (0, moment_1.default)(start_date).format("YYYY-MM-DD");
        query.end_date = (0, moment_1.default)(end_date).format("YYYY-MM-DD");
        delete query.date;
        this.DrivesFilterService.setStartDate((0, moment_1.default)(start_date).valueOf());
        this.DrivesFilterService.setEndDate((0, moment_1.default)(end_date).valueOf());
        if (context === "instructor") {
            query.instructor = this.UserService.getCurrentUser();
        }
        query.statusIsnt = "Inactive - Scheduling Conflict";
        return query;
    };
    CalendarService.prototype.getDrivesMethod = function (filterQuery, context) {
        switch (context) {
            case "instructor":
                return this.CalendarModel.getInstructorCalendar(filterQuery);
                break;
            case "instructor_team_calendar":
                return this.CalendarModel.filterAdminCalendar(filterQuery);
                break;
            case "student":
                return this.CalendarModel.getStudentCalendar(filterQuery);
                break;
            case "admin":
                return this.CalendarModel.filterAdminCalendar(filterQuery);
                break;
        }
    };
    CalendarService.prototype.disableFullCalendarControls = function () {
        var buttons = document.getElementsByClassName("fc-button");
        for (var i = 0; i < buttons.length; i++) {
            var button = buttons[i];
            button.setAttribute("disabled", "true");
        }
    };
    CalendarService.prototype.enableFullCalendarControls = function () {
        var buttons = document.getElementsByClassName("fc-button");
        this.$timeout(function () {
            for (var i = 0; i < buttons.length; i++) {
                var button = buttons[i];
                button.removeAttribute("disabled");
            }
        }, 500);
    };
    CalendarService.prototype.setCalendarViewData = function (data) {
        this.DrivesFilterService.setStartDate(data.startDate);
        this.DrivesFilterService.setEndDate(data.endDate);
        this.setCalendarView(data.viewType);
    };
    CalendarService.prototype.getCalendarEvents = function (data) {
        var _this = this;
        this.$rootScope.$broadcast("CALENDAR_LOADING");
        this.disableFullCalendarControls();
        var queryData = {
            start_date: data.startDate,
            end_date: data.endDate,
            context: data.context,
        };
        var filterQuery = this.getFilterQuery(queryData);
        var getDrives = this.getDrivesMethod(filterQuery, data.context);
        return getDrives.then(function (response) {
            // DrivesFilterService.setAgenda(response);
            var formattedResponse = _this.processCalendar(response);
            var entities = (0, flatten_1.default)((0, filter_1.default)(formattedResponse, function (value, key) {
                // @ts-ignore
                return key !== "flag" && key !== "stats";
            }));
            _this.setCalendarItems(entities);
            _this.$rootScope.$broadcast("UPDATE_CALENDAR");
            // re-enable the prev and next buttons
            _this.enableFullCalendarControls();
        });
    };
    CalendarService.prototype.handleDateChange = function (data) {
        this.setCalendarViewData(data);
        this.getCalendarEvents(data);
    };
    CalendarService.prototype.handleCalDestroy = function (data) {
        //used to reload drives/events for proper dates when calendar page is reloaded
        this.setCalendarViewData(data);
    };
    return CalendarService;
}());
CalendarService.$inject = [
    "DrivesFilterService",
    "CalendarModel",
    "$state",
    "$rootScope",
    "UserService",
    "$timeout",
    "VueStoreFactory",
];
exports.default = CalendarService;
